export const doesGivenPathEndWith = (
  givenPath: string,
  endWithPath: string
) => {
  return (
    givenPath.endsWith(endWithPath) ||
    givenPath.endsWith(endWithPath.slice(0, endWithPath.length - 1)) ||
    givenPath.slice(0, givenPath.length - 1).endsWith(endWithPath) ||
    givenPath
      .slice(0, givenPath.length - 1)
      .endsWith(endWithPath.slice(0, endWithPath.length - 1))
  );
};
